import BaseAPI from '../base'

function fetchChain(link) {
    return BaseAPI.sendGet(`/chain/fetch/${link}`);
}

export default {
    fetchChain
}